

import { useState } from 'react'
import { AiFillCaretLeft } from '@react-icons/all-files/ai/AiFillCaretLeft'
import { AiFillCaretRight } from '@react-icons/all-files/ai/AiFillCaretRight'
import { FaCamera } from '@react-icons/all-files/fa/FaCamera'
import ImageSlider from '../../../commons/ImageSlider'
import './ImagesFiche.css'

const ImagesFiche = ({ item }) => {

    const [isFullScreen, setIsFullScreen] = useState(false)

    const handleClose = () => {
        setIsFullScreen(false)
    }

    const handleOpen = () => {
        setIsFullScreen(true)
    }

    const renderFullScreen = () => {
        return isFullScreen
            ? <ImageSlider idFiche={item.IdFiche} onClose={handleClose} />
            : null
    }


    const getUrlImage = () => {

        if (item.UrlImage) {
            return item.UrlImage
        }

        switch (item.IdTypeFiche) {
            case 1:
                return '/images/doctor.svg'
            case 2:
                return '/images/pharmacie.svg'
            case 3:
                return '/images/service.svg'
        }
    }

    return (
        <>
            {renderFullScreen()}
            <div className="images-fiche" onClick={handleOpen}>
                <img className="image" width="100" height="100" src={getUrlImage()} alt="label" onClick={handleOpen} />
                <div className="overlay">
                    <AiFillCaretLeft className="controls" />
                    <FaCamera className="camera" />
                    <AiFillCaretRight className="controls" />
                </div>
            </div>
        </>
    )
}

export default ImagesFiche